import React, { useState } from 'react';
import { Button, Modal } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEye, faFilePdf } from '@fortawesome/free-solid-svg-icons';

import ShowModelData from './ShowModelData';
import Loader from 'Common/Loader';

import { HttpStatus } from 'modules/core';
import notistack from 'modules/core/notistack';

import {
    generateStoreToMayaveInvoice,
    generateMayaveToStoreInvoice,
    GenerateStoreToMayaveAcceptInvoice
} from '../services/return-to-mayave-request.service';

interface ActionReturnToMayaveProps {
    selectedId: string;
    status: string;
    reloadDataSource(): void;
    showMayaveChallanPdf: boolean;
}

const ActionReturnToMayaveRequest: React.FC<ActionReturnToMayaveProps> = ({
    selectedId,
    status,
    reloadDataSource,
    showMayaveChallanPdf,
}) => {
    const [loading, setLoading] = useState(false);
    const [showViewModal, setShowViewModal] = useState(false);
    const [pdfData, setPdfData] = useState<string | null>(null);
    const [pdfTitle, setPdfTitle] = useState<string>('Delivery Challan');
    const [showPdfModal, setShowPdfModal] = useState(false);
    const [shouldShowChallanAfterModalSubmit, setShouldShowChallanAfterModalSubmit] = useState(false);

    const isMainStore = localStorage.getItem('mayavePurityEdit');

    const handlePdfGenerate = async () => {
        setLoading(true);
        try {
            const response = await generateStoreToMayaveInvoice(selectedId);
            if (response.status === HttpStatus.Success) {
                setPdfTitle('Delivery Challan');
                setPdfData(response.data);
                setShowPdfModal(true);
            } else {
                notistack.notifyFromApi(response);
            }
        } catch (error: any) {
            notistack.notifyFromApi(error?.message || 'PDF generation failed.');
        } finally {
            setLoading(false);
        }
    };

    const handleMayaveToStoreChallan = async () => {
        setLoading(true);
        try {
            const response = await generateMayaveToStoreInvoice(selectedId);
            if (response.status === HttpStatus.Success) {
                setPdfTitle('Estimate receipt');
                setPdfData(response.data);
                setShowPdfModal(true);
            } else {
                notistack.notifyFromApi(response);
            }
        } catch (err: any) {
            notistack.notifyFromApi(err?.message || 'Failed to generate PDF.');
        } finally {
            setLoading(false);
        }
    };
    const finalInvoice = async () => {
        setLoading(true);
        try {
            const response = await GenerateStoreToMayaveAcceptInvoice(selectedId);
            if (response.status === HttpStatus.Success) {
                setPdfTitle('Invoice');
                setPdfData(response.data);
                setShowPdfModal(true);
            } else {
                notistack.notifyFromApi(response);
            }
        } catch (err: any) {
            notistack.notifyFromApi(err?.message || 'Failed to generate PDF.');
        } finally {
            setLoading(false);
        }
    };

    return (
        <>
            {loading && <Loader />}

            <button className='btn btn-sm action-btn' title='View' onClick={() => setShowViewModal(true)}>
                <FontAwesomeIcon icon={faEye} />
            </button>

            <button className='btn btn-sm action-btn' title='Delivery Challan' onClick={handlePdfGenerate}>
                <FontAwesomeIcon icon={faFilePdf} className='text-danger' />
            </button>

            {showMayaveChallanPdf && (
                <button
                    className="btn btn-sm action-btn"
                    title="Estimate receipt"
                    onClick={handleMayaveToStoreChallan}
                >
                    <FontAwesomeIcon icon={faFilePdf} className="text-secondary" />
                </button>
            )}

            {status === "Accepted" && (
                <button
                    className="btn btn-sm action-btn"
                    title="Final invoice"
                    onClick={finalInvoice}
                >
                    <FontAwesomeIcon icon={faFilePdf} className="text-primary" />
                </button>
            )}



            {/* View Modal */}
            <Modal size='xl' show={showViewModal} onHide={() => setShowViewModal(false)} centered>
                <Modal.Header closeButton>
                    <Modal.Title>Return Request</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <ShowModelData
                        selectedId={selectedId}
                        status={status}
                        onClose={() => {
                            setShowViewModal(false);
                            setShouldShowChallanAfterModalSubmit(false);
                        }}
                        onSave={async () => {
                            reloadDataSource();
                            setShowViewModal(false);

                            if (shouldShowChallanAfterModalSubmit) {
                                setShouldShowChallanAfterModalSubmit(false);
                                await handleMayaveToStoreChallan();
                            }
                        }}
                    />
                </Modal.Body>
            </Modal>

            {/* PDF Modal */}
            <Modal size='lg' show={showPdfModal} onHide={() => setShowPdfModal(false)} centered>
                <Modal.Header closeButton>
                    <Modal.Title>{pdfTitle}</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    {pdfData ? (
                        <iframe
                            src={`data:application/pdf;base64,${pdfData}`}
                            width="100%"
                            height="500px"
                            style={{ border: 'none' }}
                        />
                    ) : (
                        <p>No PDF available.</p>
                    )}
                </Modal.Body>
            </Modal>
        </>
    );
};

export default ActionReturnToMayaveRequest;